/**
 * Type guard to check if an item is an upcoming event
 */
export const isUpcomingEvent = (item: unknown): boolean => {
  return (
    typeof item === 'object' &&
    item !== null &&
    '__typename' in item &&
    (item as { __typename?: string }).__typename === 'DatoCmsPctEvent' &&
    'isPreEvent' in item &&
    (item as { isPreEvent?: boolean }).isPreEvent === true
  )
}
